// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';
import { type CardBrand, detectCardBrand } from '@tectonics/prs/card-brand';

export function validateCardSecurityCode(cardSecurityCode: string, cardNumber: string): ?UserInputValidationError {
  const cardBrand = detectCardBrand(cardNumber);

  if(!cardSecurityCode) {
    return { id: 'empty' };
  } else if (!getCardSecurityPatternFromBrand(cardBrand).test(cardSecurityCode)) {
    return { id: 'invalid-pattern' };
  }
}

function getCardSecurityPatternFromBrand(cardBrand: ?CardBrand): RegExp {
  if (cardBrand === 'amex') {
    return /^\d{4}$/;
  }
  return /^\d{3}$/;
}
